<mat-form-field
  class="w-full! cursor-text rounded-sm border border-[#E4E9EF]! focus-within:border-[#005FFF]! {{
    hasError ? 'border-red-500!' : ''
  }}"
>
  <mat-label class="tracking-wider font-normal!">{{ label }}</mat-label>
  <div matPrefix mat-icon-button>
    @if (icon) {
    <img class="ml-4 mr-1" src="{{ icon }}" alt="Icono de {{ label }}" />
    }
  </div>
  <input
    class="font-normal!"
    matInput
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    type="{{ type }}"
    id="{{ label }}"
    [disabled]="isDisabled"
    [maxLength]="maxLength ? maxLength : 99999999999"
  />
</mat-form-field>
